import { EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { UserRole } from '@40seas/entities/users';
import { PaymentOptionWithFee, PaymentOptionWithFeeSchema } from '@40seas/models';
import { z } from 'zod';

export const InvoiceResultSchema = z.object({
    dueDate: ZodDate.optional(),
    total: z.number().optional(),
    totalFee: z.number().optional(),
    paymentOptionWithFee: PaymentOptionWithFeeSchema.optional(),
    totalDiscount: z.number().optional(),
    paymentMethodId: z.string().optional(),
    setBy: EnumSchema(UserRole).optional(),
});

export class InvoiceResult extends FromSchema(InvoiceResultSchema) {
    dueDate?: Date;
    total?: number;
    totalFee?: number;
    paymentOptionWithFee?: PaymentOptionWithFee;
    totalDiscount?: number;
    paymentMethodId?: string;
    setBy?: UserRole;
}
